<template>
  <v-card
    v-if="items && items.length"
    class="ma-0 mx-3 mb-3 pa-0"
    elevation="0"
  >
    <v-card
      :elevation="expandCarousel ? 0 : 3"
      class="ma-0 pa-0"
      v-bind:style="cardStyle"
    >
      <v-img
        v-if="expandCarousel"
        :src="items[0].src"
        :contain="true"
        max-height="200px"
        @click="zoomModel = true"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              width="2"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
      <v-carousel
        v-else
        v-model="model"
        cycle
        :height="calculatedHeight"
        hide-delimiters
        :show-arrows="false"
      >
        <v-carousel-item v-for="(item, i) in items" :key="i">
          <v-img
            :src="
              item.web_src && !$vuetify.breakpoint.xsOnly
                ? item.web_src
                : item.src
            "
            :height="calculatedHeight"
            :contain="contain"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  width="2"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-carousel-item>
      </v-carousel>
    </v-card>
    <v-row
      justify="center"
      class="ma-0 pa-0 vetalfa-subtitle py-1 text-center"
      v-if="text"
    >
      {{ text }}
    </v-row>
    <v-row
      v-else-if="!text && items.length > 1"
      class="ma-0 pa-0 carousel-icons-row pb-2 mt-2"
      align="center"
      justify="center"
    >
      <v-icon
        v-for="(item, j) in items"
        :key="j + 'circle'"
        light
        color="primary"
        size="8"
        @click="model = j"
        >{{ j == model ? circleIcon : circleOutlineIcon }}</v-icon
      >
    </v-row>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-bind:content-class="
        !$vuetify.breakpoint.xsOnly ? 'carousel-dialog-class' : ''
      "
      :scrollable="false"
      v-model="zoomModel"
    >
      <v-row
        aling="space-between"
        id="carousel-close-dialog-row"
        justify="start"
        class="black pa-0 ma-0 vetalfa-row"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 pr-2 py-2" justify="end">
            <v-btn
              @click="zoomModel = false"
              text
              icon
              right
              class="text-none white--text"
            >
              <v-icon large>{{ mdiClose }}</v-icon>
            </v-btn>
          </v-row>
        </v-col>

        <v-col cols="12" class="ma-0 pa-0">
          <v-img :src="items[0].src"></v-img>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" class="ma-0 pa-0" align-self="end">
          <v-row
            justify="start"
            align="end"
            class="ma-0 px-2 pa-0 py-1 white vetalfa-card-title"
            v-if="text"
          >
            {{ text }}
          </v-row>
        </v-col>
      </v-row>
    </v-dialog>
  </v-card>
</template>

<style>
.carousel-icons-row {
  height: 10px;
}
.carousel-dialog-class {
  max-width: 80%;
  max-height: 80%;
}
</style>

<script>
import {} from "@mdi/js";
import labels from "@/constants/labels.js";
import { mdiCircle, mdiCircleOutline, mdiClose } from "@mdi/js";
export default {
  name: "Carousel",
  props: {
    items: {
      type: Array,
    },
    height: {
      type: Number,
      default: 200,
      required: false,
    },
    contain: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
    },
    expandCarousel: {
      type: Boolean,
      default: false,
    },
    route: {
      type: String,
      default: "",
    },
  },
  computed: {
    calculatedHeight() {
      return this.height + (this._getWindowWidth() > 500 ? 40 : 0);
    },
    cardStyle() {
      return `cursor:pointer;background-color:${
        this.items[this.model].color || "white"
      }`;
    },
  },
  mounted() {},
  methods: {},
  data() {
    return {
      model: 0,
      circleIcon: mdiCircle,
      circleOutlineIcon: mdiCircleOutline,
      mdiClose,
      zoomModel: false,
      labels,
    };
  },
  created() {},
};
</script>